import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { VTLBackgroundMaterial as t } from "../shaders/VTLBackgroundMaterial.js";
import { VTLCircleMaterial as i } from "../shaders/VTLCircleMaterial.js";
import { VTLFillMaterial as e, VTLOutlineMaterial as a } from "../shaders/VTLFillMaterial.js";
import { VTLLineMaterial as o } from "../shaders/VTLLineMaterial.js";
import { VTLIconMaterial as r, VTLTextMaterial as s } from "../shaders/VTLSymbolMaterial.js";
import n from "./Filter.js";
import { StyleDefinition as l } from "./StyleDefinition.js";
import h from "./StyleProperty.js";
import { THIN_LINE_HALF_WIDTH_THRESHOLD as u } from "../../webgl/definitions.js";

var p = /*#__PURE__*/function () {
  function p(t, i, e, a) {
    _classCallCheck(this, p);

    switch (this.type = t, this.typeName = i.type, this.id = i.id, this.source = i.source, this.sourceLayer = i["source-layer"], this.minzoom = i.minzoom, this.maxzoom = i.maxzoom, this.filter = i.filter, this.layout = i.layout, this.paint = i.paint, this.z = e, this.uid = a, t) {
      case 0:
        this._layoutDefinition = l.backgroundLayoutDefinition, this._paintDefinition = l.backgroundPaintDefinition;
        break;

      case 1:
        this._layoutDefinition = l.fillLayoutDefinition, this._paintDefinition = l.fillPaintDefinition;
        break;

      case 2:
        this._layoutDefinition = l.lineLayoutDefinition, this._paintDefinition = l.linePaintDefinition;
        break;

      case 3:
        this._layoutDefinition = l.symbolLayoutDefinition, this._paintDefinition = l.symbolPaintDefinition;
        break;

      case 4:
        this._layoutDefinition = l.circleLayoutDefinition, this._paintDefinition = l.circlePaintDefinition;
    }

    this._layoutProperties = this._parseLayout(this.layout), this._paintProperties = this._parsePaint(this.paint);
  }

  _createClass(p, [{
    key: "getFeatureFilter",
    value: function getFeatureFilter() {
      return void 0 !== this._featureFilter ? this._featureFilter : this._featureFilter = n.createFilter(this.filter);
    }
  }, {
    key: "getLayoutProperty",
    value: function getLayoutProperty(t) {
      return this._layoutProperties[t];
    }
  }, {
    key: "getPaintProperty",
    value: function getPaintProperty(t) {
      return this._paintProperties[t];
    }
  }, {
    key: "getLayoutValue",
    value: function getLayoutValue(t, i, e) {
      var a;
      var o = this._layoutProperties[t];
      return o && (a = o.getValue(i, e)), void 0 === a && (a = this._layoutDefinition[t].default), a;
    }
  }, {
    key: "getPaintValue",
    value: function getPaintValue(t, i, e) {
      var a;
      var o = this._paintProperties[t];
      return o && (a = o.getValue(i, e)), void 0 === a && (a = this._paintDefinition[t].default), a;
    }
  }, {
    key: "isPainterDataDriven",
    value: function isPainterDataDriven() {
      var t = this._paintProperties;
      if (t) for (var _i in t) {
        if (t[_i].isDataDriven) return !0;
      }
      return !1;
    }
  }, {
    key: "_parseLayout",
    value: function _parseLayout(t) {
      var i = {};

      for (var _e in t) {
        var _a = this._layoutDefinition[_e];
        _a && (i[_e] = new h(_a, t[_e]));
      }

      return i;
    }
  }, {
    key: "_parsePaint",
    value: function _parsePaint(t) {
      var i = {};

      for (var _e2 in t) {
        var _a2 = this._paintDefinition[_e2];
        _a2 && (i[_e2] = new h(_a2, t[_e2]));
      }

      return i;
    }
  }, {
    key: "computeAttributesKey",
    value: function computeAttributesKey(t, i, e, a) {
      var o = 0,
          r = 0;

      var _iterator = _createForOfIteratorHelper(i),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _s = _step.value;
          var _t = 3;

          if (!_s || _s !== a) {
            var _i2 = e[_s],
                _a3 = _i2.isLayout,
                _o = _i2.isOptional,
                _r = _a3 ? this.getLayoutProperty(_s) : this.getPaintProperty(_s);

            _t = null != _r && _r.interpolator ? 2 : null != _r && _r.isDataDriven ? 1 : _o && !_r ? 3 : 0;
          }

          r |= _t << o, o += 2;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return r << 3 | t;
    }
  }]);

  return p;
}();

var g = /*#__PURE__*/function (_p) {
  _inherits(g, _p);

  var _super = _createSuper(g);

  function g(i, e, a, o) {
    var _this;

    _classCallCheck(this, g);

    _this = _super.call(this, i, e, a, o), _this.backgroundMaterial = new t(_this.computeAttributesKey(0, t.ATTRIBUTES, t.ATTRIBUTES_INFO));
    return _this;
  }

  return g;
}(p);

var y = /*#__PURE__*/function (_p2) {
  _inherits(y, _p2);

  var _super2 = _createSuper(y);

  function y(t, i, o, r) {
    var _this2;

    _classCallCheck(this, y);

    _this2 = _super2.call(this, t, i, o, r);

    var s = _this2.getPaintProperty("fill-color"),
        n = _this2.getPaintProperty("fill-opacity"),
        l = _this2.getPaintProperty("fill-pattern");

    _this2.hasDataDrivenColor = null == s ? void 0 : s.isDataDriven, _this2.hasDataDrivenOpacity = null == n ? void 0 : n.isDataDriven, _this2.hasDataDrivenFill = _this2.hasDataDrivenColor || _this2.hasDataDrivenOpacity || (null == l ? void 0 : l.isDataDriven);

    var h = _this2.getPaintProperty("fill-outline-color");

    _this2.outlineUsesFillColor = !h, _this2.hasDataDrivenOutlineColor = null == h ? void 0 : h.isDataDriven, _this2.hasDataDrivenOutline = h ? h.isDataDriven : !!s && s.isDataDriven, _this2.hasDataDrivenOutline = (h ? _this2.hasDataDrivenOutlineColor : _this2.hasDataDrivenColor) || _this2.hasDataDrivenOpacity, _this2.fillMaterial = new e(_this2.computeAttributesKey(1, e.ATTRIBUTES, e.ATTRIBUTES_INFO)), _this2.outlineMaterial = new a(_this2.computeAttributesKey(2, _this2.outlineUsesFillColor ? a.ATTRIBUTES_FILL : a.ATTRIBUTES_OUTLINE, _this2.outlineUsesFillColor ? a.ATTRIBUTES_INFO_FILL : a.ATTRIBUTES_INFO_OUTLINE), _this2.outlineUsesFillColor);
    return _this2;
  }

  return y;
}(p);

var D = /*#__PURE__*/function (_p3) {
  _inherits(D, _p3);

  var _super3 = _createSuper(D);

  function D(t, i, e, a) {
    var _this3;

    _classCallCheck(this, D);

    var r, s, n, l, h, p, g, y, _D;

    _this3 = _super3.call(this, t, i, e, a);

    var P = _this3.getPaintProperty("line-pattern");

    if (_this3.lineMaterial = new o(_this3.computeAttributesKey(3, o.ATTRIBUTES, o.ATTRIBUTES_INFO, P ? "line-dasharray" : "")), _this3.hasDataDrivenLine = (null == (r = _this3.getPaintProperty("line-blur")) ? void 0 : r.isDataDriven) || (null == (s = _this3.getPaintProperty("line-color")) ? void 0 : s.isDataDriven) || (null == (n = _this3.getPaintProperty("line-gap-width")) ? void 0 : n.isDataDriven) || (null == (l = _this3.getPaintProperty("line-offset")) ? void 0 : l.isDataDriven) || (null == (h = _this3.getPaintProperty("line-opacity")) ? void 0 : h.isDataDriven) || (null == (p = _this3.getPaintProperty("line-pattern")) ? void 0 : p.isDataDriven) || (null == (g = _this3.getPaintProperty("line-dasharray")) ? void 0 : g.isDataDriven) || (null == (y = _this3.getLayoutProperty("line-cap")) ? void 0 : y.isDataDriven) || (null == (_D = _this3.getPaintProperty("line-width")) ? void 0 : _D.isDataDriven), _this3.canUseThinTessellation = !1, !_this3.hasDataDrivenLine) {
      var _t2 = _this3.getPaintProperty("line-width");

      if (!_t2 || "number" == typeof _t2 && .5 * _t2 < u) {
        var _t3 = _this3.getPaintProperty("line-offset");

        (!_t3 || "number" == typeof _t3 && 0 === _t3) && (_this3.canUseThinTessellation = !0);
      }
    }

    return _this3;
  }

  _createClass(D, [{
    key: "getDashKey",
    value: function getDashKey(t, i) {
      var e;

      switch (i) {
        case 0:
        default:
          e = "Butt";
          break;

        case 1:
          e = "Round";
          break;

        case 2:
          e = "Square";
      }

      return "dasharray-[".concat(t.toString(), "]-").concat(e);
    }
  }]);

  return D;
}(p);

var P = /*#__PURE__*/function (_p4) {
  _inherits(P, _p4);

  var _super4 = _createSuper(P);

  function P(t, i, e, a) {
    var _this4;

    _classCallCheck(this, P);

    var o, n, l, h, u, p, g, y, D, _P, c, d;

    _this4 = _super4.call(this, t, i, e, a), _this4.iconMaterial = new r(_this4.computeAttributesKey(4, r.ATTRIBUTES, r.ATTRIBUTES_INFO)), _this4.textMaterial = new s(_this4.computeAttributesKey(6, s.ATTRIBUTES, s.ATTRIBUTES_INFO)), _this4.hasDataDrivenIcon = (null == (o = _this4.getPaintProperty("icon-color")) ? void 0 : o.isDataDriven) || (null == (n = _this4.getPaintProperty("icon-halo-blur")) ? void 0 : n.isDataDriven) || (null == (l = _this4.getPaintProperty("icon-halo-color")) ? void 0 : l.isDataDriven) || (null == (h = _this4.getPaintProperty("icon-halo-width")) ? void 0 : h.isDataDriven) || (null == (u = _this4.getPaintProperty("icon-opacity")) ? void 0 : u.isDataDriven) || (null == (p = _this4.getLayoutProperty("icon-size")) ? void 0 : p.isDataDriven), _this4.hasDataDrivenText = (null == (g = _this4.getPaintProperty("text-color")) ? void 0 : g.isDataDriven) || (null == (y = _this4.getPaintProperty("text-halo-blur")) ? void 0 : y.isDataDriven) || (null == (D = _this4.getPaintProperty("text-halo-color")) ? void 0 : D.isDataDriven) || (null == (_P = _this4.getPaintProperty("text-halo-width")) ? void 0 : _P.isDataDriven) || (null == (c = _this4.getPaintProperty("text-opacity")) ? void 0 : c.isDataDriven) || (null == (d = _this4.getLayoutProperty("text-size")) ? void 0 : d.isDataDriven);
    return _this4;
  }

  return P;
}(p);

var c = /*#__PURE__*/function (_p5) {
  _inherits(c, _p5);

  var _super5 = _createSuper(c);

  function c(t, e, a, o) {
    var _this5;

    _classCallCheck(this, c);

    _this5 = _super5.call(this, t, e, a, o), _this5.circleMaterial = new i(_this5.computeAttributesKey(5, i.ATTRIBUTES, i.ATTRIBUTES_INFO));
    return _this5;
  }

  return c;
}(p);

var d = /*#__PURE__*/function () {
  function d(t, i, e) {
    _classCallCheck(this, d);

    var a, o, r, s, n;
    var l;
    this.allowOverlap = t.getLayoutValue("icon-allow-overlap", i), this.ignorePlacement = t.getLayoutValue("icon-ignore-placement", i), this.keepUpright = t.getLayoutValue("icon-keep-upright", i), this.optional = t.getLayoutValue("icon-optional", i), this.rotationAlignment = t.getLayoutValue("icon-rotation-alignment", i), 2 === this.rotationAlignment && (this.rotationAlignment = e ? 0 : 1), l = t.getLayoutProperty("icon-anchor"), null != (a = l) && a.isDataDriven ? this._anchorProp = l : this.anchor = t.getLayoutValue("icon-anchor", i), l = t.getLayoutProperty("icon-offset"), null != (o = l) && o.isDataDriven ? this._offsetProp = l : this.offset = t.getLayoutValue("icon-offset", i), l = t.getLayoutProperty("icon-padding"), null != (r = l) && r.isDataDriven ? this._paddingProp = l : this.padding = t.getLayoutValue("icon-padding", i), l = t.getLayoutProperty("icon-rotate"), null != (s = l) && s.isDataDriven ? this._rotateProp = l : this.rotate = t.getLayoutValue("icon-rotate", i), l = t.getLayoutProperty("icon-size"), null != (n = l) && n.isDataDriven ? this._sizeProp = l : this.size = t.getLayoutValue("icon-size", i);
  }

  _createClass(d, [{
    key: "update",
    value: function update(t, i) {
      this._anchorProp && (this.anchor = this._anchorProp.getValue(t, i)), this._offsetProp && (this.offset = this._offsetProp.getValue(t, i)), this._paddingProp && (this.padding = this._paddingProp.getValue(t, i)), this._rotateProp && (this.rotate = this._rotateProp.getValue(t, i)), this._sizeProp && (this.size = this._sizeProp.getValue(t, i));
    }
  }]);

  return d;
}();

var f = /*#__PURE__*/function () {
  function f(t, i, e) {
    _classCallCheck(this, f);

    var a, o, r, s, n, l, h, u, p, g, y;
    var D;
    this.allowOverlap = t.getLayoutValue("text-allow-overlap", i), this.ignorePlacement = t.getLayoutValue("text-ignore-placement", i), this.keepUpright = t.getLayoutValue("text-keep-upright", i), this.optional = t.getLayoutValue("text-optional", i), this.rotationAlignment = t.getLayoutValue("text-rotation-alignment", i), 2 === this.rotationAlignment && (this.rotationAlignment = e ? 0 : 1), D = t.getLayoutProperty("text-anchor"), null != (a = D) && a.isDataDriven ? this._anchorProp = D : this.anchor = t.getLayoutValue("text-anchor", i), D = t.getLayoutProperty("text-justify"), null != (o = D) && o.isDataDriven ? this._justifyProp = D : this.justify = t.getLayoutValue("text-justify", i), D = t.getLayoutProperty("text-letter-spacing"), null != (r = D) && r.isDataDriven ? this._letterSpacingProp = D : this.letterSpacing = t.getLayoutValue("text-letter-spacing", i), D = t.getLayoutProperty("text-line-height"), null != (s = D) && s.isDataDriven ? this._lineHeightProp = D : this.lineHeight = t.getLayoutValue("text-line-height", i), D = t.getLayoutProperty("text-max-angle"), null != (n = D) && n.isDataDriven ? this._maxAngleProp = D : this.maxAngle = t.getLayoutValue("text-max-angle", i), D = t.getLayoutProperty("text-max-width"), null != (l = D) && l.isDataDriven ? this._maxWidthProp = D : this.maxWidth = t.getLayoutValue("text-max-width", i), D = t.getLayoutProperty("text-offset"), null != (h = D) && h.isDataDriven ? this._offsetProp = D : this.offset = t.getLayoutValue("text-offset", i), D = t.getLayoutProperty("text-padding"), null != (u = D) && u.isDataDriven ? this._paddingProp = D : this.padding = t.getLayoutValue("text-padding", i), D = t.getLayoutProperty("text-rotate"), null != (p = D) && p.isDataDriven ? this._rotateProp = D : this.rotate = t.getLayoutValue("text-rotate", i), D = t.getLayoutProperty("text-size"), null != (g = D) && g.isDataDriven ? this._sizeProp = D : this.size = t.getLayoutValue("text-size", i), D = t.getLayoutProperty("text-writing-mode"), null != (y = D) && y.isDataDriven ? this._writingModeProp = D : this.writingMode = t.getLayoutValue("text-writing-mode", i);
  }

  _createClass(f, [{
    key: "update",
    value: function update(t, i) {
      this._anchorProp && (this.anchor = this._anchorProp.getValue(t, i)), this._justifyProp && (this.justify = this._justifyProp.getValue(t, i)), this._letterSpacingProp && (this.letterSpacing = this._letterSpacingProp.getValue(t, i)), this._lineHeightProp && (this.lineHeight = this._lineHeightProp.getValue(t, i)), this._maxAngleProp && (this.maxAngle = this._maxAngleProp.getValue(t, i)), this._maxWidthProp && (this.maxWidth = this._maxWidthProp.getValue(t, i)), this._offsetProp && (this.offset = this._offsetProp.getValue(t, i)), this._paddingProp && (this.padding = this._paddingProp.getValue(t, i)), this._rotateProp && (this.rotate = this._rotateProp.getValue(t, i)), this._sizeProp && (this.size = this._sizeProp.getValue(t, i)), this._writingModeProp && (this.writingMode = this._writingModeProp.getValue(t, i));
    }
  }]);

  return f;
}();

export { g as BackgroundStyleLayer, c as CircleStyleLayer, y as FillStyleLayer, d as IconLayout, D as LineStyleLayer, p as StyleLayer, P as SymbolStyleLayer, f as TextLayout };